import { render, staticRenderFns } from "./titulo.vue?vue&type=template&id=45ad9b00&scoped=true"
import script from "./titulo.vue?vue&type=script&lang=js"
export * from "./titulo.vue?vue&type=script&lang=js"
import style0 from "./titulo.vue?vue&type=style&index=0&id=45ad9b00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ad9b00",
  null
  
)

export default component.exports